import React from "react";
import { Helmet } from "react-helmet";
import { useMediaQuery, useTheme } from "@mui/material";
import LandingDesktop from "./LandingDesktop";
import LandingMobile from "./LandingMobile";

const Landing = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // md and above

  return (
    <>
      <Helmet>
        <title>Farmapp - Digital Agriculture Platform</title>
      </Helmet>
      {isDesktop ? <LandingDesktop /> : <LandingMobile />}
    </>
  );
};

export default Landing;
